export default {
  sectionTitle: {
    id: 'buyback_categories_section_title',
    defaultMessage: 'Wanna sell something else?',
  },
  alternativeNext: {
    id: 'buyback_categories_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'buyback_categories_alternative_previous',
    defaultMessage: 'Previous',
  },
  categorySmartphone: {
    id: 'buyback_categories_smartphone',
    defaultMessage: 'Other phones',
  },
  categoryIphone: {
    id: 'buyback_categories_iphone',
    defaultMessage: 'Iphone',
  },
  categoryTablet: {
    id: 'buyback_categories_tablet',
    defaultMessage: 'Tablet',
  },
  categoryMacbook: {
    id: 'buyback_categories_macbook',
    defaultMessage: 'Macbook',
  },
  categoryGamingConsole: {
    id: 'buyback_categories_gaming_console',
    defaultMessage: 'Gaming consoles',
  },
  categoryAudio: {
    id: 'buyback_categories_audio',
    defaultMessage: 'Audio',
  },
}
